module.exports = __webpack_public_path__ + "static/media/TenancyDeposit Scheme_NI.aece8dc7.png";